import { observer } from 'mobx-react'
import moment from 'moment'
import React, { FC } from 'react'
import FormInput from '../../../../../components/customElements/FormInput'
import { isAdmin, isDealer } from '../../../../../services/AccountService'
import AddPhotosBlock from './AddPhotosBlock'
import CompleteDrawerModelInfo from './CompleteDrawerModelInfo'
import {
  forbiddenPhotoStatuses,
  useServiceInformationAccordion,
} from './useServiceInformationAccordion'

type EditServiceInformationFormProps = {
  serviceStore: any
  type: number
  preventUploadPics: boolean
  isEdit: boolean
}

const EditServiceInformationForm: FC<EditServiceInformationFormProps> = ({
  serviceStore,
  type,
  preventUploadPics,
  isEdit,
}) => {
  const {
    intl,
    canEditSubscriberData,
    currentServiceData,
    serviceInformationAccordionFormStore,
  } = useServiceInformationAccordion(serviceStore, type)

  const isToGuaranteeType = currentServiceData?.status === 8

  const canAddPics =
    ((canEditSubscriberData && isEdit && !isAdmin()) ||
      (!forbiddenPhotoStatuses.includes(currentServiceData.status) &&
        !preventUploadPics)) &&
    !isToGuaranteeType

  const onlyDateOfMaintenance =
    currentServiceData.status === 6.2 &&
    currentServiceData.dataCheckingStatus === 0

  const canChangeMaintenance =
    (isToGuaranteeType && !isEdit) || (isEdit && isDealer())

  return (
    <>
      {!isToGuaranteeType && (
        //@ts-ignore
        <FormInput
          api={serviceInformationAccordionFormStore}
          type={'text'}
          propName={'dateOfMaintenance'}
          fullWidth
          mask={'99-99-9999'}
          label={intl.formatMessage({ id: 'Дата выполнения работ' })}
          withoutErrorText={true}
          defaultValue={
            currentServiceData.dateOfMaintenance
              ? moment(currentServiceData.dateOfMaintenance).format(
                  'DD.MM.YYYY',
                )
              : moment().format('DD.MM.YYYY')
          }
        />
      )}
      {isToGuaranteeType && canChangeMaintenance && (
        //@ts-ignore
        <FormInput
          api={serviceInformationAccordionFormStore}
          type={'text'}
          propName={'dateOfVisit'}
          fullWidth
          mask={'99-99-9999'}
          label={intl.formatMessage({ id: 'Дата обслуживания' })}
          withoutErrorText={true}
          defaultValue={
            currentServiceData.dateOfVisit
              ? moment(currentServiceData.dateOfVisit).format('DD.MM.YYYY')
              : moment().format('DD.MM.YYYY')
          }
          error={moment(
            serviceInformationAccordionFormStore.data?.dateOfVisit,
            'DD-MM-YYYY',
          ).isAfter(moment())}
        />
      )}
      {!onlyDateOfMaintenance && (
        <>
          <CompleteDrawerModelInfo
            serviceStore={serviceStore}
            shortType
            isToGuaranteeType={isToGuaranteeType}
            hideWorkDescription={!isDealer() && isEdit}
          />
          {canAddPics && (
            <AddPhotosBlock
              settingsField={'MaintenanceCompleted'}
              formStore={serviceInformationAccordionFormStore}
              serviceStore={serviceStore}
            />
          )}
        </>
      )}
    </>
  )
}

export const validateNumberInput = (event: any) => {
  return /^[0-9]+$/.test(event.target.value) || event.target.value === ''
}

export default observer(EditServiceInformationForm)
